<!--预估利润-->
<template>
    <el-dialog
        :title="msg('预估利润')"
        :visible.sync="costVisible"
        :close-on-click-modal="false"
        size="mini"
        width="500px"
        custom-class="profit-dialog"
    >
        <div class="profit-body">
            <div class="profit-top">
                <div class="profit-top-item">
                    <div class="profit-amount">
                        <div class="profit-amount-row">
                            <span class="profit-label">预估进账：</span>
                            <span class="profit-value">{{ escrowAmountTWD }}</span>
                            <span class="profit-unit profit-unit-small">TWD</span>
                        </div>
                        <div class="profit-amount-row" style="color:red;font-size:16px;">
                            <span class="profit-label-placeholder"></span>
                            <span class="profit-value">{{ escrowAmountCNY }}</span>
                            <span class="profit-unit profit-unit-small">CNY</span>
                        </div>
                    </div>
                </div>
                <div class="profit-top-item">
                    <span class="profit-label">参考汇率：</span>
                    <span class="profit-value">{{ rate!=4.5? rate: '4.5' }}</span>
                </div>
            </div>

            <div class="profit-list">
                <div class="profit-row">
                    <span class="profit-row-label">商品成本：</span>
                    <span class="profit-row-value">{{ productSumCost }}</span>
                    <span style="font-size: 14px;" class="profit-unit">CNY</span>
                </div>
                <div class="profit-row">
                    <span class="profit-row-label">运费成本：</span>
                    <!-- <span class="profit-row-value">{{ expCost }}</span> -->
                    <el-input-number size="mini" v-model="expProfit" controls-position="right" :min="0" :max="100" @change="updateProfit"></el-input-number>
                    <span style="font-size: 14px;" class="profit-unit">CNY</span>
                </div>
                <div class="profit-row">
                    <span class="profit-row-label">打包成本：</span>
                    <!-- <span class="profit-row-value">{{ costSetting.dabaoCost }}</span> -->
                    <el-input-number size="mini" v-model="dabaoCost" controls-position="right" :min="0" :max="100" @change="updateProfit"></el-input-number>
                    <span style="font-size: 14px;" class="profit-unit">CNY</span>
                </div>
                <div class="profit-row">
                    <span class="profit-row-label">进店成本：</span>
                    <!-- <span class="profit-row-value">{{ costSetting.jindianCost }}</span> -->
                    <el-input-number size="mini" v-model="jindianCost" controls-position="right" :min="0" :max="100" @change="updateProfit"></el-input-number>
                    <span style="font-size: 14px;" class="profit-unit">CNY</span>
                </div>
                <div class="profit-row">
                    <span class="profit-row-label">其它成本：</span>
                    <!-- <span class="profit-row-value">{{ costSetting.otherCost }}</span> -->
                    <el-input-number size="mini" v-model="otherCost" controls-position="right" :min="0" :max="100" @change="updateProfit"></el-input-number>
                    <span style="font-size: 14px;" class="profit-unit">CNY</span>
                </div>
            </div>
            <div class="profit-bottom" style="color:red;">
                <span class="profit-bottom-label">预估利润：</span>
                <span class="profit-bottom-value">{{ profit }}</span>
                <span style="font-size: 14px;" class="profit-unit">CNY</span>
            </div>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="costVisible = false">{{msg('取消')}}</el-button>
            <el-button type="primary" @click="costVisible = false">{{msg("确定")}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "CostViewDialog",
    data(){
        return {
            costVisible: false,
            costDialogOrder: null,
            rate: 4.5, // 参考汇率
            expCost: 0, // 运费成本
            dabaoCost: 0, // 打包成本
            jindianCost: 0, // 进店成本
            otherCost: 0, // 其他成本
            
            escrowAmountTWD: 0,
            escrowAmountCNY: 0,
            productSumCost: 0,
            expProfit: 0,
            profit: 0,
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
    },
    methods: {
        showDialog(order, detail, setting){
            this.costDialogOrder = order;
            this.rate = Number(setting.rate) || 4.5;
            this.expCost = Number(setting.expCost) || 0;
            this.dabaoCost = Number(setting.dabaoCost) || 0;
            this.jindianCost = Number(setting.jindianCost) || 0;
            this.otherCost = Number(setting.otherCost) || 0;
            this.escrowAmountTWD = (Number(detail.escrowAmount) || 0).toFixed(2);
            this.escrowAmountCNY = ((Number(detail.escrowAmount) || 0)/this.rate).toFixed(2);
            this.costVisible = true;
            this.productSumCost = this.getSumCost(order);
            this.expProfit = this.getExpCost(detail);
            this.profit = this.getProfit();
        },
        getSumCost(order){
            let productSumCost = 0;
            order.details.forEach(e => {
                productSumCost += e.cost;
            });
            return productSumCost>0? ((Number(productSumCost)/100).toFixed(2)): 0;
        },
        getExpCost(detail){
            let expProfit = (this.expCost * (Number(detail.weightConsign)/1000)).toFixed(2);
            return expProfit>0? Number(expProfit): 0;
        },
        getProfit(){
            let profit = (Number(this.escrowAmountCNY) - Number(this.productSumCost) - Number(this.expProfit) - Number(this.dabaoCost) - Number(this.jindianCost) - Number(this.otherCost)).toFixed(2);
            return Number(profit);
        },
        updateProfit(){
            this.profit = this.getProfit();
        }
    }

}
</script>
<style scoped>
.profit-dialog /deep/ .el-dialog__header{
    background: #3f73c5;
    padding: 10px 16px;
}

.profit-dialog /deep/ .el-dialog__title{
    color: #fff;
    font-weight: bold;
    font-size: 20px;
}

.profit-dialog /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}

.profit-dialog /deep/ .el-dialog__body{
    padding: 20px 24px;
}

.profit-body{
    font-size: 18px;
    color: #000;
}

.profit-top{
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-weight: bold;
    margin-bottom: 18px;
}

.profit-label{
    margin-right: 6px;
}

.profit-label-placeholder{
    display: inline-block;
    width: 90px;
    margin-right: 6px;
}

.profit-value{
    font-weight: bold;
}

.profit-unit{
    margin-left: 6px;
}

.profit-unit-small{
    font-size: 14px;
}

.profit-amount{
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.profit-amount-row{
    display: flex;
    align-items: baseline;
}

.profit-list{
    padding: 6px 0;
}

.profit-row{
    display: flex;
    align-items: baseline;
    margin: 15px 0;
}

.profit-row-label{
    width: 110px;
}

.profit-row-value{
    font-weight: bold;
}

.profit-bottom{
    margin-top: 22px;
    font-weight: bold;
    font-size: 20px;
}

.profit-footer /deep/ .el-button{
    min-width: 90px;
    border-radius: 4px;
}

.profit-footer /deep/ .el-button--default{
    background: #3f73c5;
    border-color: #3f73c5;
    color: #fff;
}

.profit-footer /deep/ .el-button--primary{
    background: #3f73c5;
    border-color: #3f73c5;
}
</style>
